module.exports = __webpack_public_path__ + "static/media/icon4.9958c9e2.svg";